import styled from '@emotion/styled';
import { useGlobal } from '../../hooks';
import { When } from 'react-if';
import {
    getPageUrl,
    GoogleAggregateChip,
    SourceIcon,
    useAnalyticsClickEvent,
} from 'rwl-ui';
import { ClickTargets } from 'rwl-shared/dist/models/analytics';

const GoogleAggregateContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: var(--rwl-spacing-md);
    border: 1px solid var(--rwl-color-neutral-border);
    border-radius: var(--rwl-radius-lg);
    padding: var(--rwl-spacing-sm) 12px;
    &:hover {
        background-color: var(--rwl-palette-gray-100);
    }
`;

// Convert write review URL to view all reviews URL
const getReviewsUrl = (url: string | undefined): string | undefined => {
    if (!url) return undefined;
    // Convert writereview to reviews to show all reviews instead of review editor (used in portfolio)
    return url.replace('/writereview?', '/reviews?');
};

export const GoogleAggregate = () => {
    const { config } = useGlobal();
    const sendClickEvent = useAnalyticsClickEvent();

    if (!config) {
        return null;
    }
    const { gmbIntegration } = config;
    const reviewsUrl = getReviewsUrl(gmbIntegration?.url);
    return (
        <When condition={gmbIntegration && gmbIntegration.reviewCount}>
            <GoogleAggregateContainer>
                <GoogleAggregateChip
                    source="GMB"
                    count={gmbIntegration?.reviewCount || 0}
                    rating={gmbIntegration?.reviewRating || 0}
                    onClick={() => {
                        sendClickEvent({
                            url: getPageUrl(),
                            target: ClickTargets.EXTERNAL_REVIEWS,
                        });
                        // Open Google Business Profile reviews page
                        window.open(reviewsUrl, '_blank');
                    }}
                />
            </GoogleAggregateContainer>
        </When>
    );
};

const LinkContainer = styled.div`
    padding: var(--rwl-spacing-sm) 0;
    a {
        color: var(--rwl-text-hint);
        padding-left: var(--rwl-spacing-sm);
        text-decoration: underline;
    }

    display: flex;
    align-items: center;
`;

export const MiniGoogleAggregate = () => {
    const { config } = useGlobal();
    const sendClickEvent = useAnalyticsClickEvent();

    if (!config) {
        return null;
    }
    const { gmbIntegration } = config;

    // Convert to view all reviews URL
    const reviewsUrl = getReviewsUrl(gmbIntegration?.url);

    return (
        <When condition={gmbIntegration && gmbIntegration.reviewCount}>
            <LinkContainer>
                <SourceIcon source="GMB" style={{ width: 12, height: 12 }} />
                <a
                    href={reviewsUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{ fontSize: 14 }}
                    onClick={() =>
                        sendClickEvent({
                            url: getPageUrl(),
                            target: ClickTargets.EXTERNAL_REVIEWS,
                        })
                    }
                >
                    {(gmbIntegration?.reviewRating || 0).toFixed(1)}{' '}
                    {`(${gmbIntegration.reviewCount} reviews)`}
                </a>
            </LinkContainer>
        </When>
    );
};
